export default {
    newDesign: true,
    ageRules: {
        min: 5,
        max: 17,
    },
    parameters: {
        landing_id: "EnQMPUK",
        segment: 3,
        success_page: "success_long_new_design",
    },
    title: "We'll create a personalised learning path for your child | Kodland",
    downtimeUrl: "https://www.kodland.org/",
    startPage: {
        title: "We'll create a personalised learning path for your child",
        subtitle:
            "Answer a few quick questions and we'll recommend the best course and show you what skills your child can develop.",
        image: {
            url: "/welcome/uk_personalized_quiz_fwd_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/uk_personalized_quiz_fwd_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Find the right course 🚀",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Thank you for your interest in Kodland.",
        subtitle:
            "Please note that our courses require a keyboard and mouse; therefore, phones, tablets, and devices without these features are not compatible.",
    },
    quizRotateBySteps: {
        1: {
            title: "How old is your child?",
            type: "age",
            button: "",
        },
        2: {
            question:
                "How much time does your child spend on devices (phone, computer or tablet)?",
            answers: [
                "Less than 1 hour a day",
                "1 to 4 hours a day",
                "More than 4 hours a day",
            ],
        },
        3: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
            subtitle:
                "What's waiting for your child in the classes?<br>✅ They'll explore digital creativity: animation, illustration, 3D modelling, design<br>✅ They'll create their first projects (collage, website, 3D world, animation for games and cartoons, etc.)<br>✅ They'll learn tools to create digital artwork",
            button: "Excellent!",
        },
        4: {
            question:
                "Does your child have access to a laptop or desktop PC for studying?",
            answers: [
                "💻✅ Yes, they have their own device",
                "💻👥 Yes, but they share it with others",
                {
                    answer: "No, no regular access 🚫",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            question: "What does your child enjoy creating most?",
            answers: [
                "🎨 Drawing characters and illustrations",
                "🎬 Creating animations and short videos",
                "✏️ Making posters, covers and stickers",
                "🗿 Creating objects and worlds in 3D",
            ],
        },
        6: {
            question: "How does your child prefer to work?",
            answers: [
                "🌈 Coming up with ideas and a visual style",
                "🖌️ Working with colours and drawing",
                "👥 Creating projects with other kids",
                "📐 Building 3D objects",
            ],
        },
        7: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",
            subtitle:
                "We offer both individual and group learning formats, and we take each child's age into account to tailor the process in the best possible way.",
            button: "Let's go!",
        },
        8: {
            question: "What learning format suits them best?",
            answers: [
                "🚀 Trying different types of creativity",
                "🎨 Learning design, drawing and animation",
                "🧠 Learning through creative activities",
                "🎮 Going deeper into 3D and more advanced software",
            ],
        },
        9: {
            typeInfo: "loaderScreen",
            sliderImages: [
                "/welcome/it_personalized_quiz_fwd_r1_desk.png",
                "/welcome/it_personalized_quiz_fwd_r2_desk.png",
                "/welcome/it_personalized_quiz_fwd_r3_desk.png",
            ],
            sliderImagesMobile: [
                "/welcome/it_personalized_quiz_fwd_r1_mob.png",
                "/welcome/it_personalized_quiz_fwd_r2_mob.png",
                "/welcome/it_personalized_quiz_fwd_r3_mob.png",
            ],
            duration: 5000,
            textLoader: "We're analysing your answers to find the best course…",
            titleLoader:
                "We're analysing your answers to find the perfect course and teacher",
            subtitleLoader: "⭐ 4.8 / 5 — based on over 50,000 reviews",
        },
        10: {
            dynamicTypeInfo: [
                {
                    condition: [
                        {
                            step: 5,
                            answer: "🗿 Creating objects and worlds in 3D",
                        },
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/it_personalized_quiz_fwd_final_modeling.png",
                        title: "🧱 Enter the world of 3D | Kodland",
                        subtitle:
                            "Learn to create 3D objects and worlds with professional tools and take creativity beyond the screen.",
                        button: "👉 Sign up now",
                    },
                },
                {
                    default: true,
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/it_personalized_quiz_fwd_final_creativity.png",
                        title: "🧩 Take creativity to the next level | Kodland",
                        subtitle:
                            "Design, illustration and animation in one course — to turn ideas into unique digital projects.",
                        button: "👉 Sign up now",
                    },
                },
            ],
        },
        11: {
            title: "Complete your contact details to access the free course",
            type: "one-page-contacts",
            subtitle: "",
            button: "Almost done 🔥",
        },
        12: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        13: {
            title: "Check these details to complete the registration ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Please ensure you have a working computer or laptop available for the lesson. It's also important that you accompany your child during the class. Each session is individual and personalised.",
            button: "What else?",
        },
        14: {
            title: "Before the trial, check your email and WhatsApp for updates 📞",
            typeInfo: "whatsapp",
            subtitle:
                "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
            button: "What else?",
        },
        15: {
            title: "The lesson will take place on our platform 💻",
            typeInfo: "classroom",
            subtitle:
                "You'll get a link and a unique code via WhatsApp and email. Just click the link, it will take you straight to the lesson. No extra apps, no downloads.",
            button: "Got it ✅",
        },
    },
};
